<kendo-card class="farlinklcd-card" xmlns="http://www.w3.org/1999/html">
  <kendo-card-header class="k-hstack">
    <div>
      <h1 kendoCardTitle><kendo-icon name="home"></kendo-icon> Farlink </h1>
      <p kendoCardSubtitle> LCD Analyser </p>
    </div>
  </kendo-card-header>
  <hr kendoCardSeparator/>
  <kendo-card-body>
    <code>
      {{ fastLinkLcd?.lcddata0 }}<br/>
      {{ fastLinkLcd?.lcddata1 }}
    </code>

    <hr kendoCardSeparator  />
    <br/>
    <kendo-card-actions  >
      <button kendoButton  (click)="OnKey(eFASTLINK_SUBCOMMAND.eREQUESTED_KEY_UP)">
        <span class="k-icon k-i-arrow-up  k-icon-md  k-color-primary"></span>
      </button>
      <hr kendoCardSeparator orientation="horizontal"/>
      <button kendoButton  (click)="OnKey(eFASTLINK_SUBCOMMAND.eREQUESTED_KEY_DOWN)">
        <span class="k-icon k-i-arrow-down k-icon-md  k-color-primary"></span>
      </button>

      <hr kendoCardSeparator orientation="vertical"/>

      <button kendoButton  (click)="OnKey(eFASTLINK_SUBCOMMAND.eREQUESTED_KEY_GRAPH)">
        <span class="k-icon k-i-plus-outline k-icon-sm  k-color-primary"></span>
      </button>

      <button kendoButton  (click)="OnKey(eFASTLINK_SUBCOMMAND.eREQUESTED_KEY_ENTER)">
        <span class="k-icon k-i-play k-icon-sm  k-color-primary"></span>
      </button>

      <button kendoButton  (click)="OnKey(eFASTLINK_SUBCOMMAND.eREQUESTED_SCREEN)">
        <span class="k-icon k-i-reload k-icon-sm  k-color-primary"></span>
      </button>

    </kendo-card-actions>
  </kendo-card-body>
  <kendo-card-footer >

  </kendo-card-footer>

</kendo-card>







